const NavigationTab = (props) =>
  <button onClick={props.onClick} className={`navigation-tab ${props.isActive ? 'is-active' : ''}`}>
    { props.text }
  </button>

export default NavigationTab
